import type { WebapiEndpointBuilder } from '@/api/webapi.ts';

export type CancelEspBody = {
  signalRConnectionId: string;
  currencyPair: string;
  tiering: string;
};

export type CancelEspResponse = {};

export const cancelEsp = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<CancelEspResponse, CancelEspBody>({
    query: (body) => ({
      url: '/fxSpotFwd/esp/cancel',
      method: 'POST',
      body: {
        dataStreamId: body.signalRConnectionId,
        streamKey: `${body.currencyPair}&&${body.tiering}`, // EspId -> ex: "EUR/USD&&SPOT_AI|A"
      },
    }),
  });
};
